import React from "react";

export const GeometricDivider = ({ className = "" }) => {
  return (
    <div className={`flex items-center justify-center gap-6 my-12 ${className}`} aria-hidden="true">
      <div className="h-px w-24 md:w-40 bg-gradient-to-r from-transparent via-gold to-transparent" />
      <Star8 />
      <div className="h-px w-24 md:w-40 bg-gradient-to-r from-transparent via-gold to-transparent" />
    </div>
  );
};

export const Star8 = ({ size = 26, color = "#C8A24B" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="opacity-90">
    <g stroke={color} strokeWidth="1.4" fill="none">
      <rect x="14" y="14" width="36" height="36" transform="rotate(0 32 32)" />
      <rect x="14" y="14" width="36" height="36" transform="rotate(45 32 32)" />
      <circle cx="32" cy="32" r="4" fill={color} stroke="none" />
    </g>
  </svg>
);

export default GeometricDivider;
